export { SettingWrapper } from "./component";
export type {
  SettingWrapperProps,
  SettingWrapperStyleProps,
  StyledDescriptionProps,
  StyledInputAreaProps,
  StyledLabelProps,
  StyledSettingWrapperProps,
} from "./types";
